import { useEffect } from 'react';
import { useSnackbar } from 'notistack';
import axios from 'axios';
// config
import { HOST_API } from 'config';


// ----------------------------------------------------------------------
const axiosInstance = axios.create({
  baseURL: HOST_API
});


const setAxiosBaseURL = (baseURL) => {
  axiosInstance.defaults.baseURL = baseURL;
};

const AxiosInterceptor = ({ children }) => {

  const { enqueueSnackbar } = useSnackbar();


  useEffect(() => {
    /* eslint-disable react-hooks/exhaustive-deps */
    //  run function when component unmounts 

    const resInterceptor = response => response;
    const errInterceptor = error => {
   
      if (error?.response?.status === 500) {
        enqueueSnackbar("Une erreur inattendue s’est produite");

      }
      return Promise.reject(error);
    };


    const interceptor = axiosInstance.interceptors.response.use(resInterceptor, errInterceptor);

    return () => axiosInstance.interceptors.response.eject(interceptor);

  }, []);

  return children;
};

export { AxiosInterceptor,setAxiosBaseURL };

export default axiosInstance;

